import { render } from "./OrderLegalTranslation.vue?vue&type=template&id=f31cee54&scoped=true"
import script from "./OrderLegalTranslation.vue?vue&type=script&lang=js"
export * from "./OrderLegalTranslation.vue?vue&type=script&lang=js"

import "./OrderLegalTranslation.vue?vue&type=style&index=0&id=f31cee54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f31cee54"

export default script